import React from "react";
import { ClipboardCheck, HelpCircle, NotebookPen } from "lucide-react";
import { WORK_TYPE_FILTERS, workTypeLabel } from "../utils/workType";
import "./WorkType.css";

const ICONS = { assessment: ClipboardCheck, homework: NotebookPen };

// Outlined label with an icon, so the type never relies on colour alone and
// never looks like a completion status pill.
export const WorkTypeTag = ({ type, className = "" }) => {
  const Icon = ICONS[type] || HelpCircle;
  return (
    <span className={`work-type-tag work-type-${type || "unclear"}${className ? ` ${className}` : ""}`}>
      <Icon size={12} aria-hidden="true" />{workTypeLabel(type)}
    </span>
  );
};

export const WorkTypeFilter = ({ value, onChange, label = "Filter by work type", className = "" }) => (
  <div className={`work-type-filter${className ? ` ${className}` : ""}`} role="group" aria-label={label}>
    {WORK_TYPE_FILTERS.map(([filter, text]) => (
      <button key={filter} type="button" aria-pressed={value === filter}
        className={`work-type-filter-option${value === filter ? " active" : ""}`} onClick={() => onChange(filter)}>
        {text}
      </button>
    ))}
  </div>
);
